<template>
  <div>
    <div class="collapse-container">
        <div class="collapse-content" @click="toggleCollapse">
            <p class="landing-collapse-title">
                <slot name="title"/>
            </p>
            <div>
              <div :class="['collapse-icon', collapsed && 'icon-rotate']">
                <IconChevronDown />
              </div>
            </div>
        </div>
        <Transition name="collapse">
            <div v-if="collapsed">
                <slot/>
            </div>
        </Transition>
    </div>
  </div>
</template>

<script>
import IconChevronDown from '@/components/Icons/IconChevronDown';

export default {
  name: 'LandingCollapse',
  components: {
    IconChevronDown,
  },
  data() {
    return {
      collapsed: false,
    };
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>
